import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@modules/auth/hooks';
import { STUDY_INSIGHTS_SAMPLE_TRACKING_QUERY_KEY } from '../constants/api';
import { fetchSampleTrackingV2 } from '../services/sample-tracking.service';
import { SampleTrackingResponse } from '../types';
import { UseQuerySampleTrackingParams } from './useQuerySampleTracking.types';

const useQuerySampleTrackingV2 = <TError = unknown>(
  params: UseQuerySampleTrackingParams,
  options?: Omit<
    UseQueryOptions<
      SampleTrackingResponse | undefined,
      TError,
      SampleTrackingResponse | undefined,
      Array<string | UseQuerySampleTrackingParams>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<SampleTrackingResponse | undefined> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([STUDY_INSIGHTS_SAMPLE_TRACKING_QUERY_KEY, params], async () => await fetchSampleTrackingV2(params), {
    ...options,
    enabled: isAuthenticated === true && enabledOption,
  });
};

export default useQuerySampleTrackingV2;
